import axios from "axios";
import { Notification, MessageBox, Message } from "element-ui";
import store from "@/store";
import { getToken } from "@/utils/auth";
const qs = require("qs");
const paramsFormat = function(params) {

  let resParams = {};
  for (let i in params) {
    let val = params[i];
    if (Array.isArray(val) && val.length > 0) {
      resParams[i] = val;
    } else if (val && typeof val === "object" && JSON.stringify(val) != "{}") {
      resParams[i] = val;
    } else if (val || val === 0 ) {
      resParams[i] = val;
    }
  }
  return resParams;
};

axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 120000
});
service.interceptors.request.use(
  config => {
    config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    if (getToken()) {
      config.headers["Authorization"] = "Bearer " + getToken();
    }

    config.vconfig = config.vconfig || {};

    if (config.vconfig.noBaseApi) {
      config.baseURL = process.env.VUE_APP_NO_BASE_API;
    }
    // if (config.vconfig.stakeApi) {
    //   config.baseURL = process.env.VUE_APP_STAKE_API;
    //   config.headers["Content-Type"] = config.vconfig.ContentType;
      
    // }

    if (config.vconfig.ContentType) {
      config.headers["Content-Type"] = config.vconfig.ContentType;
    }

    if (config.headers["Content-Type"] == "application/x-www-form-urlencoded") {
      config.data = qs.stringify(config.data);
    }
    if (config.vconfig.responseType) {
      config.responseType = config.vconfig.responseType;
    }
    // if(config.data){
    //   config.data = paramsFormat(config.data)
    // }
    if(config.params){
      config.params = paramsFormat(config.params)
    }
    return config;
  },
  error => {
    console.log(error);
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  res => {
    const code = res.data.code;
    if (res.config.vconfig && res.config.vconfig.noErr) {
      return res;
    }
    if (code == "-5" || res.data.error == "please login") {
      MessageBox.confirm(
        "The login status has expired. You can stay on this page or log in again",
        "System prompt",
        {
          confirmButtonText: "Login again",
          cancelButtonText: "cancel",
          type: "warning"
        }
      ).then(() => {
        store.dispatch("LogOut").then(() => {
          location.reload();
        });
      });
    } else if (+code !== 0) {
      Notification.error({
        title: res.data.error
      });
      return Promise.reject(res.data);
    } else {
      return res.data;
    }
  },
  error => {
    Message({
      message: error,
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);

export default service;
